module.exports = __webpack_public_path__ + "static/nyc-view-mobile-f0786cb3a16e3efa8d5c8fdfc22c9bb7.png";